import { ResponsiveConsumer as Responsive } from 'react-responsive-context';

export default Responsive.Consumer;
